import clsx from 'clsx';
import * as React from 'react';
import { match } from 'ts-pattern';
import { colors } from '@ovpn-ui/styles';
import Text from '../Text';
import { polymorphicAsProp } from '../types';
import * as Styled from './Badge.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const Badge = /*#__PURE__*/React.forwardRef(function Badge({
  size = 'md',
  color = colors.neutralTextTitle,
  backgroundColor = colors.secondaryBase,
  as = 'div',
  children,
  className,
  ...props
}, ref) {
  return /*#__PURE__*/_jsx(Styled.Badge, {
    ...polymorphicAsProp(as),
    ref: ref,
    className: clsx('ovpn-badge', className),
    style: {
      backgroundColor
    },
    ...props,
    children: /*#__PURE__*/_jsx(Text, {
      as: "span",
      className: "ovpn-badge-text",
      color: color,
      variant: match(size).with('xs', () => 'textXs').with('sm', () => 'textSm').with('md', () => 'textMd').run(),
      children: children
    })
  });
});
export default Badge;